import React from 'react';
import { Spinner } from './core';

interface LoadingProps {
  children: any;
  loading?: boolean;
  size?: number | string;
}

export const Loading = ({
  loading = true,
  size = '1em',
  children,
}: LoadingProps): JSX.Element => {
  if (loading) return <Spinner strokeWidth={4} size={size} />;
  return children;
};
